// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RouteCard {
  display: flex;
  gap: 1rem;
  padding: 1.2rem;
  cursor: default;
  border: 1px solid #e3e8ef;
  border-radius: 0.4rem;
  background: #fff;
}
.RouteCard .RouteCard-Select {
  flex-grow: 0;
  display: flex;
  align-items: start;
}
.RouteCard .RouteCard-Display {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.RouteCard .RouteCard-Display .RouteCard-Status,
.RouteCard .RouteCard-Display .RouteCard-Location,
.RouteCard .RouteCard-Display .RouteCard-Schedule {
  display: flex;
  gap: 0.5rem;
}
.RouteCard .RouteCard-Display .RouteCard-Status .SingleRoute {
  color: #7b7b7b;
  background: #f5f5f5;
}
.RouteCard .RouteCard-Display .RouteCard-Status .RouteControls {
  flex-grow: 1;
}
.RouteCard .RouteCard-Display .badge {
  --bs-badge-padding-x: 1.5rem;
  --bs-badge-padding-y: 0.5rem;
  font-size: 1rem;
}
.RouteCard .RouteCard-Display .RouteCard-Schedule {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.5);
}
.RouteCard .RouteControls {
  display: flex;
  gap: 0.85rem;
  justify-content: end;
  align-items: center;
}
.RouteCard .RouteControls .btn {
  padding: 0;
}
.RouteCard .RouteControls .btn > i {
  font-size: 1.2rem;
}
.RouteCard.condensed {
  align-items: center;
}
.RouteCard.condensed .RouteCard-Display {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.RouteCard.condensed .RouteCard-Location {
  align-items: center;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/RouteCard/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AACF;AAAE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AAEJ;AAAE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAEJ;AADI;;;EAGE,aAAA;EACA,WAAA;AAGN;AAAM;EACE,cAAA;EACA,mBAAA;AAER;AAAM;EACE,YAAA;AAER;AAEI;EACE,4BAAA;EACA,4BAAA;EACA,eAAA;AAAN;AAEI;EACE,iBAAA;EACA,yBAAA;AAAN;AAGE;EACE,aAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;AADJ;AAEI;EACE,UAAA;AAAN;AACM;EACE,iBAAA;AACR;AAGE;EACE,mBAAA;AADJ;AAEI;EACE,mBAAA;EACA,mBAAA;EACA,8BAAA;AAAN;AAEI;EACE,mBAAA;EACA,SAAA;AAAN","sourcesContent":[".RouteCard {\n  display: flex;\n  gap: 1rem;\n  padding: 1.2rem;\n  cursor: default;\n  border: 1px solid #e3e8ef;\n  border-radius: 0.4rem;\n  background: #fff;\n  .RouteCard-Select {\n    flex-grow: 0;\n    display: flex;\n    align-items: start;\n  }\n  .RouteCard-Display {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    .RouteCard-Status,\n    .RouteCard-Location,\n    .RouteCard-Schedule {\n      display: flex;\n      gap: 0.5rem;\n    }\n    .RouteCard-Status {\n      .SingleRoute {\n        color: #7b7b7b;\n        background: #f5f5f5;\n      }\n      .RouteControls {\n        flex-grow: 1;\n      }\n    }\n\n    .badge {\n      --bs-badge-padding-x: 1.5rem;\n      --bs-badge-padding-y: 0.5rem;\n      font-size: 1rem;\n    }\n    .RouteCard-Schedule {\n      font-size: 0.9rem;\n      color: rgba(0, 0, 0, 0.5);\n    }\n  }\n  .RouteControls {\n    display: flex;\n    gap: 0.85rem;\n    justify-content: end;\n    align-items: center;\n    .btn {\n      padding: 0;\n      > i {\n        font-size: 1.2rem;\n      }\n    }\n  }\n  &.condensed {\n    align-items: center;\n    .RouteCard-Display {\n      flex-direction: row;\n      align-items: center;\n      justify-content: space-between;\n    }\n    .RouteCard-Location {\n      align-items: center;\n      gap: 1rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
